import "./dropdown.css";
import React, { useState } from "react";
var visibilityList = "hidden";
var tap = false;
function Keybord({
  callClick,
  callClickVideo,
  echecCurrentAppel,
  cancelEchecAppel,
  tab,
}) {
  const [number, setNumber] = useState("");

  function putNumber(number) {
    tap = true;
    setNumber(number);
  }

  if (number === "") {
    visibilityList = "hidden";
    // tap = false;
  } else {
    if (tap) {
      tap = false;
      visibilityList = "hidden";
      // tap = false;
    } else {
      visibilityList = "visible";
    }
  }
  const handler = (event) => {
    if (event.key === "Enter") {
      callClick(number);
    }
  };
  if (Object.keys(echecCurrentAppel).length === 0) {
    return (
      <div className="dropdown">
        <div id="sip-dialpad" className="dropdown-menu">
          <div
            className={"scrollList flex center " + visibilityList}
            style={{
              // backgroundColor: "rgb(237 237 237)",
              // border: "1px solid #bdbdbd",
              position: "absolute",
              top: "0",
              alignSelf: "center",
              borderRadius: "6px",
              overflow: "auto",
              cursor: "pointer",
            }}
          >
            {/* <div className="w-full">
              {tab
                .filter(
                  (entry) =>
                    entry.nom.toUpperCase().includes(number.toUpperCase()) ||
                    entry.poste.toUpperCase().includes(number.toUpperCase())
                )
                .map((user) => (
                  <div
                    className="flex  border-b-2"
                    style={{
                      margin: "auto",
                      width: "150px",
                    }}
                    onClick={() => putNumber(user.poste)}
                  >
                    <div
                      style={{
                        alignSelf: "center",
                        height: "20px",
                        width: "20px",
                        borderRadius: "100%",
                        marginRight: "4px",
                        backgroundColor: "#b3b3b3",
                      }}
                    >
                      {user.photo_poste_interne !== "" ? (
                        <img
                          src={user.lien_photo_poste_interne}
                          style={{
                            borderRadius: "100%",
                          }}
                        />
                      ) : null}
                    </div>
                    <div>
                      <div style={{ fontSize: "11px" }}>{user.nom}</div>
                      <div style={{ fontSize: "11px", textAlign: "center" }}>
                        {user.poste}
                      </div>
                    </div>
                  </div>
                ))}
            </div> */}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginLeft: "30px",
            }}
          >
            <input
              type="text"
              name="number"
              id="numDisplay"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              onKeyPress={(e) => handler(e)}
            />
            <button onClick={() => setNumber(number.slice(0, -1))}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                style={{ color: "#bdbbbb" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"
                />
              </svg>
            </button>
          </div>
          <div className="dialLine">
            <button
              onClick={() => setNumber(number + 1)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="1"
            >
              1<span>&nbsp;</span>
            </button>
            <button
              onClick={() => setNumber(number + 2)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="2"
            >
              2<span>A B C</span>
            </button>
            <button
              onClick={() => setNumber(number + 3)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="3"
            >
              3<span>D E F</span>
            </button>
          </div>
          <div className="dialLine">
            <button
              onClick={() => setNumber(number + 4)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="4"
            >
              4<span>G H I</span>
            </button>
            <button
              onClick={() => setNumber(number + 5)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="5"
            >
              5<span>J K L</span>
            </button>
            <button
              onClick={() => setNumber(number + 6)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="6"
            >
              6<span>M N O</span>
            </button>
          </div>
          <div className="dialLine">
            <button
              onClick={() => setNumber(number + 7)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="7"
            >
              7<span>P Q R S</span>
            </button>
            <button
              onClick={() => setNumber(number + 8)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="8"
            >
              8<span>T U V</span>
            </button>
            <button
              onClick={() => setNumber(number + 9)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="9"
            >
              9<span>W X Y Z</span>
            </button>
          </div>
          <div className="dialLine">
            <button
              onClick={() => setNumber(number + "*")}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="*"
            >
              *<span>P Q R S</span>
            </button>
            <button
              onClick={() => setNumber(number + 0)}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="0"
            >
              0<span>T U V</span>
            </button>
            <button
              onClick={() => setNumber(number + "#")}
              type="button"
              className="btn btn-default digit cursor-pointer h-12 w-12"
              data-digit="#"
            >
              #<span>W X Y Z</span>
            </button>
          </div>
          <div className="dialLine">
            <div className="flex justify-around">
              <div className="tooltip">
                <span class="tooltiptext"> Appel audio</span>
                <button
                  style={{ marginRight: "5px" }}
                  id="MakeCall"
                  onClick={() => callClick(number)}
                  className="btnCall h-12 w-12"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    style={{ margin: "auto" }}
                  >
                    {" "}
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                  </svg>
                </button>
              </div>
              <div className="tooltip">
                <span class="tooltiptext"> Appel vidéo</span>
                <button
                  id="MakeCallVideo"
                  onClick={() => callClickVideo(number)}
                  className="btnCall h-12 w-12"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                    style={{ margin: "auto" }}
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                    />{" "}
                  </svg>
                </button>
              </div>
              {/* <button id="redial" className="btnCall h-12 w-12">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                style={{ margin: "auto" }}
              >
                {" "}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />{" "}
              </svg>
            </button> */}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          backgroundColor: "#1f2937",
          position: "absolute",
          top: "0",
          height: "100%",
          width: "100%",
          borderRadius: "30px",
          zIndex: "1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "75px 0",
        }}
      >
        <div style={{ display: "flex" }}>
          <div
            style={{
              height: "40px",
              width: "40px",
              backgroundColor: "gray",
              borderRadius: "100%",
              margin: "0 10px",
            }}
          ></div>
          <div style={{ color: "white" }}>
            <div style={{ fontSize: "large" }}>
              {echecCurrentAppel.remoteIdentity.uri.user}
            </div>
            <div style={{ fontSize: "small", color: "#a3a3a3" }}>
              Echec de l'appel
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button
            onClick={cancelEchecAppel}
            style={{
              height: "60px",
              width: "60px",
              borderRadius: "100%",
              backgroundColor: "rgb(223 223 223 / 58%)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              style={{ color: "white", margin: "auto" }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <button
            onClick={() => callClick(echecCurrentAppel.remoteIdentity.uri.user)}
            style={{
              height: "60px",
              width: "60px",
              borderRadius: "100%",
              backgroundColor: "rgb(65 216 101)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              style={{ color: "white", margin: "auto" }}
            >
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
          </button>
        </div>
      </div>
    );
  }
}
export default Keybord;
